define("settings/routes/groups/trade", ["exports", "@ember/routing/route", "@ember/service", "@glimmer/tracking", "later/utils/object-promise-proxy"], function (_exports, _route, _service, _tracking, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/service",0,"@glimmer/tracking",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let TradeRoute = (_class = class TradeRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "settings", _descriptor2, this);

      _initializerDefineProperty(this, "store", _descriptor3, this);

      _initializerDefineProperty(this, "groups", _descriptor4, this);
    }

    async model() {
      const groups = this.settings.isAccountOwner ? await this.store.query('group', {
        filter: {
          account_id: this.auth.currentAccount.id
        }
      }) : [];
      await Promise.all(groups.map(group => {
        return this.auth.currentAccount.rolloutLinkinbioInstagramlessPage ? (0, _objectPromiseProxy.arrayPromiseProxy)(group.get('adaptedLinkinbioPages').toArray()) : (0, _objectPromiseProxy.arrayPromiseProxy)(group.get('adaptedLinkinbioPages'));
      }));
      return groups;
    }

    setupController(controller, model) {
      this.groups = model;
      const sortedGroups = this.groups.sortBy('name');
      controller.setProperties({
        groups: sortedGroups,
        temporaryGroups: sortedGroups
      });
    }

    get canAccessOCE() {
      return this.auth.currentAccount.rolloutOcePhase1;
    }

    deactivate() {
      this.controller.setProperties({
        movedSocialProfiles: [],
        movedSocialIdentities: [],
        profilesMovedBetweenGroups: []
      });
      this.groups.forEach(group => {
        group.set('temporaryIdentities', null);
        group.set('traded', null);
        const identitiesToDelete = [];
        group.socialIdentities.forEach(identity => {
          identity.set('temporaryProfiles', null);

          if (!this.canAccessOCE && identity.get('socialProfiles').length === 0 || this.canAccessOCE && !identity.influencerId && identity.get('socialProfiles').length === 0) {
            identitiesToDelete.addObject(identity);
          }
        });
        identitiesToDelete.forEach(identity => {
          group.socialIdentities.removeObject(identity);
        });
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "groups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  })), _class);
  _exports.default = TradeRoute;
});